// @flow
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { pb, pt, p } from 'styled-components-spacing';

import theme from '@theme';

export const StyledCover = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 1;
  background-color: #80808082;
  ${breakpoint('mobile', 'desktop')`
    ${p(2)}
    `}
`;

export const StyledBody = styled.div`
  background-color: white;
  border-radius:8px;
  display: flex;
  flex-direction: column;
  margin: auto;
  position: fixed;
  top: 50%;
  right: 50%;
  transform: translate(50%, -50%);
  ${p(4)}
  z-index: 1;
  ${breakpoint('desktop')`
  width:700px;
  `}
  ${breakpoint('tablet', 'desktop')`
  width:500px;
`}
  ${breakpoint('mobile', 'tablet')`
  max-width:500px;
  margin:auto;
  width:80%;
`}
`;
export const StyledHeading = styled.p`
  font-family: OpenSans, 'Open Sans';
  font-weight: normal;
  float:left;
  align-self:${props => (props.center ? 'center' : 'start')};
  color: #5FA6BF;
  font-weight:bold;
  ${pb(3)}
  ${pt(4)}
  ${breakpoint('desktop')`
    ${pt(0)}
    font-size: 30px;
    color: #5FA6BF;
  `}
  ${breakpoint('mobile', 'desktop')`
 font-size:24px;
`}
`;

export const StyledText = styled.p`
  font-family: OpenSans, 'Open Sans';
  font-weight: normal;
  align-self: ${props => (props.center ? 'center' : 'start')};
  text-align: ${props => (props.center ? 'center' : '')};
  color: ${theme.colors.mediumGray};
  ${pb(4)}

  ${breakpoint('desktop')`
  font-size: 24px;
  `}
  ${breakpoint('mobile', 'desktop')`
 font-size:20px;
`}
`;

export const StyledIconWrapper = styled.div`
  height: 20px;
  width: 20px;
  float: right;
  text-align: end;
  align-self: end;
  cursor: pointer;
`;

export const StyledInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: max-content;
  justify-content: space-between;
  ${breakpoint('desktop')`
  width: 50%;
  `}
  ${breakpoint('mobile', 'desktop')`
  width: 80%;
  `}
`;
